import React from 'react';
import getApplicantInformationLabel from '@/Utils/getLabelsFunctions';
import ApplicantInformationType from '@/Models/ApplicantInformationType';
import InfoChoiceSelector from './components/InfoChoiceSelector';
import UIStrings from '@/Utils/UIStrings';
import { AccordionContent, AccordionItem } from '@/Components/shadcn';
import RequestInformationAccordionTrigger from './components/RequestInformationAccordionTrigger';

const startUpInformationToggles: ApplicantInformationType[] = [
    ApplicantInformationType.WhyWorkInStartup,
    ApplicantInformationType.RankRemunerationLearningBalance,
    ApplicantInformationType.StructureImportance,
    ApplicantInformationType.PersonalProject,
    ApplicantInformationType.WhereDoYouSeeYourself,
];

const StartupInformationAccordion = () => {
    return (
        <AccordionItem
            value={UIStrings.StartupInformation}
            className="data-[state=closed]:**:data-[slot=accordion-trigger]:rounded-b-2xl"
        >
            <RequestInformationAccordionTrigger>{UIStrings.StartupInformation}</RequestInformationAccordionTrigger>
            <AccordionContent>
                {startUpInformationToggles.map((value) => (
                    <InfoChoiceSelector
                        key={ApplicantInformationType[value]}
                        label={getApplicantInformationLabel(value)}
                        name={value}
                    />
                ))}
            </AccordionContent>
        </AccordionItem>
    );
};

export default StartupInformationAccordion;
